export default "__VITE_ASSET__CyCyLuNJ__"